export const firebaseConfig = {
    apiKey: "AIzaSyCsCbVbM-3zCdoFiY1Hu6JqUYGhrnxg-lQ",
    authDomain: "limblogic-aca2c.firebaseapp.com",
    projectId: "limblogic-aca2c",
    storageBucket: "limblogic-aca2c.firebasestorage.app",
    messagingSenderId: "392593428435",
    appId: "1:392593428435:web:cff5552dabf671071e6926"
};
